<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="eight wide column">
            <Breadcrumb>
              <router-link class="section" to="/p"
                >Contratos</router-link
              >
              <i class="right chevron icon divider"></i>
              <div class="active section">{{ contract.id }}</div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div class="ui padded grid">
        <div v-show="loading" class="ui active inverted dimmer">
          <div class="ui text loader">Carregando...</div>
        </div>
        <div class="row">
          <div class="ten wide column">
            <h3 class="ui header">
              Situação:
              <a v-show="contract.state == 'pending'" class="ui orange label">Pendente</a>
              <a v-show="contract.state == 'canceled'" class="ui red label">Cancelado</a>
              <a v-show="contract.state == 'enable'" class="ui green label">Ativo</a>
            </h3>

            <div class="ui divider">

            </div>

            <div class="ui grid">
              <div class="row">
                <div class="eight wide column">
                  <h2 class="ui sub header">
                    Titular:
                  </h2>
                  <span>{{contract.owner_name}}</span>
                </div>
                <div class="eight wide column">
                  <h2 class="ui sub header">
                    CPF / CNPJ:
                  </h2>
                  <span>{{contract.owner_doc}}</span>
                </div>
              </div>
              <div class="row" v-if="!contract.is_corporate">
                <div class="sixteen wide column">
                  <h2 class="ui sub header">
                    Dependentes:
                  </h2>
                  <div v-for="(member, index) in contract.members" :key="index">- {{member.user_name}}</div>
                </div>
              </div>
              <div class="row">
                <div class="sixteen wide column">
                  <h2 class="ui sub header">
                    Plano:
                  </h2>
                  <span>{{contract.plan_name}}</span>
                </div>
              </div>
              <div class="row">
                <div class="sixteen wide column">
                  <h2 class="ui sub header">
                    Benefícios:
                  </h2>
                  <div v-for="(plan_service, index) in contract.plan_services" :key="index">- {{plan_service.description}}</div>
                </div>
              </div>
              <div class="row" v-if="contract.is_corporate">
                <div class="sixteen wide column">
                  <h2 class="ui sub header">
                    Associados:
                  </h2>
                  <div v-for="(associate, index) in contract.associates" :key="`associate-${index}`">- {{associate.user_name}}</div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import { mapState } from 'vuex';
const sleep = ms => new Promise(res => setTimeout(res, ms));

export default {
  components: { Breadcrumb, PageLayout },

  data() {
    return {
      loading: false,
      contract: {
        enable: null,
        members: [],
        plan_services: []
      }
    };
  },

  mounted() {
    this.fetch(this.$route.params.id)
  },

  methods: {
    _parseContract(contract) {
      contract.date = contract.date
        ? this.$moment(contract.date, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : null;
      return contract;
    },

    fetch(id) {
      this.loading = true;
      Api.contracts
        .fetch(id)
        .then(async response => {
          this.contract = this._parseContract(response.data.contract);
        })
        .catch(error => {
          this.loading = false;
          if (error.response) {
            this.$toast.show('Erro ao buscar contrato', 'error');
            this.$router.push({ name: 'contracts' });
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.$scrollTop();
          this.loading = false;
        });
    },
  }
};
</script>
